const users = {
    page_title: 'Quản lý người dùng',
    title: 'Quản lý người dùng',
    subtitle: 'Quản lý danh tính người dùng bao gồm tạo người dùng, sửa thông tin người dùng, xem nhật ký người dùng, đặt lại mật khẩu và xóa người dùng.',
    create: 'Thêm người dùng',
    create_subtitle: 'Cung cấp ít nhất một trong các trường sau để tiếp tục.',
    error_missing_identifier: 'Bạn phải cung cấp ít nhất một định danh để tạo người dùng.',
    user_name: 'Người dùng',
    application_name: 'Từ ứng dụng',
    latest_sign_in: 'Đăng nhập gần nhất',
    create_form_username: 'Tên đăng nhập',
    create_form_password: 'Mật khẩu',
    create_form_name: 'Họ và tên',
    placeholder_name: 'Nguyễn Văn A',
    placeholder_email: 'jdoe@example.com',
    placeholder_username: 'user123',
    placeholder_phone: '+84 912 345 678',
    unnamed: 'Chưa có tên',
    search: 'Tìm theo tên, email, số điện thoại hoặc tên đăng nhập',
    check_user_detail: 'Xem chi tiết người dùng',
    placeholder_title: 'Quản lý người dùng',
    placeholder_description: 'Mỗi người dùng có một hồ sơ chứa toàn bộ thông tin người dùng. Hồ sơ gồm dữ liệu cơ bản, danh tính mạng xã hội và dữ liệu tùy chỉnh.',
    dev_tenant_data_retention_notice: 'Trong các tenant dev, tài khoản người dùng cũ hơn 90 ngày sẽ tự động bị xóa. <a>Tìm hiểu thêm</a>',
};
export default Object.freeze(users);
